export const esDict = {
  'Account recovery requires verified contact information':
    'La recuperación de la cuenta requiere información de contacto verificada',
  'Back to Sign In': 'Volver a inicio de sesión',
  'Change Password': 'Cambiar contraseña',
  Changing: 'Cambiando',
  Code: 'Código',
  Confirm: 'Confirmar',
  'Confirm a Code': 'Confirmar un código',
  'Confirm Password': 'Confirmar contraseña',
  'Confirm Sign In': 'Confirmar inicio de sesión',
  'Confirm Sign Up': 'Confirmar registro',
  'Confirm TOTP Code': 'Confirmar código TOTP',
  'Confirmation Code': 'Código de confirmación',
  Confirming: 'Confirmando',
  'Create a new account': 'Crear una cuenta nueva',
  'Creating Account': 'Creando cuenta',
  Email: 'Email',
  'Forgot Password': 'Olvidé mi contraseña',
  'Incorrect username or password': 'Nombre de usuario o contraseña incorrecta',
  'Invalid password format': 'Formato de contraseña inválido',
  'Invalid phone number format': 'Formato de número de teléfono inválido',
  'Forgot your password?': '¿Olvidó su contraseña?',
  'Hide password': 'Ocultar contraseña',
  'Loading...': 'Cargando...',
  'New Password': 'Nueva contraseña',
  or: 'o',
  Password: 'Contraseña',
  'Phone Number': 'Número de teléfono',
  'Resend a Code': 'Reenviar un código',
  'Reset your password': 'Restablecer su contraseña',
  'Reset your Password': 'Restablecer su Contraseña',
  'Resend Code': 'Reenviar código',
  'Send Code': 'Enviar código',
  Sending: 'Enviando',
  'Setup TOTP': 'Configurar TOTP',
  'Show password': 'Mostrar contraseña',
  'Sign in': 'Iniciar sesión',
  'Sign In': 'Iniciar Sesión',
  'Sign In with Amazon': 'Iniciar Sesión con Amazon',
  'Sign In with Apple': 'Iniciar Sesión con Apple',
  'Sign In with Facebook': 'Iniciar Sesión con Facebook',
  'Sign In with Google': 'Iniciar Sesión con Google',
  'Sign in to your account': 'Iniciar sesión en tu cuenta',
  'Sign Out': 'Cerrar sesión',
  'Sign Up': 'Crear cuenta',
  'Signing in': 'Iniciando sesión',
  Skip: 'Omitir',
  Submit: 'Enviar',
  'User already exists': 'El usuario ya existe',
  'User does not exist': 'El usuario no existe',
  Username: 'Nombre de usuario',
  'Username cannot be empty': 'El nombre de usuario no puede estar vacío',
  Verify: 'Verificar',
  'Verify Contact': 'Verificar contacto',
};
